<script>
  import LinkComponent from "$lib/contentTypes/LinkComponent.svelte";
  import { activeProductUrl } from "$lib/utilities/menu-helpers";

  export let data;
  export let productRootUrl;

  const label = "Primary Utility Menu";
  const id = "primary-nav-utility";

  let clazz = "";
  export { clazz as class };
  const isActiveProduct = activeProductUrl(productRootUrl, data);
</script>

<nav aria-label={label} class="lg:order-1 order-2 bg-neutral-100 lg:bg-black lg:h-40">
  <h2 {id} class="sr-only">{label}</h2>
  <div
    class="lg:max-w-screen-lg mx-auto list-none flex flex-col lg:gap-8 lg:flex-row relative lg:justify-between lg:items-center px-0 py-0 lg:px-56 h-full"
  >
    <ul class="lg:mx-20 h-full flex flex-col lg:flex-row lg:gap-48 {clazz}" aria-labelledby={id}>
      {#each data as menuItem}
        <li
          class="relative lg:flex flex-col lg:justify-center lg:items-center"
          aria-current={isActiveProduct(menuItem)}
        >
          <LinkComponent
            data={{
              ...menuItem,
              active: isActiveProduct(menuItem)
            }}
            id={menuItem?.sys?.id ? `${id}-${menuItem.sys.id}` : ""}
          />

          <!-- active product indicator -->
          {#if isActiveProduct(menuItem)}
            <span
              class="absolute text-white bg-white px-10 rotate-45 rounded-2 mt-60 hidden lg:block not-sr-only"
              >&nbsp;</span
            >
          {/if}
        </li>
      {/each}
    </ul>
  </div>
</nav>
